// extracted by mini-css-extract-plugin
export default {"myfooter":"footer_myfooter__LCoz2"};